/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../_helpers'
import { customersService } from '../../_services/customers.service'
import UserMessages from '../Messages/UserMessages'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'

import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

class Form extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      key: 'info',
      id: this.props.id,
      isReseller: false,
      data: this.props.itemsInitialValues
    }

  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {

    const { id } = this.state;

    if (id) {

      this.setState({ loading: true });

      await customersService.getById(id)
        .then((res) => {

          let data = res.data;

          if (data.customerType === 0) {
            data["customerTypeIsLegal"] = false
          } else {
            data["customerTypeIsLegal"] = true
          }

          console.log(data);

          this.setState({ data: data, loading: false })

        })
        .catch((error) => {

          console.log(error);

          this.setState({ loading: false });

        });

    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== undefined && nextProps.id !== this.state.id) {
      this.setState({ id: nextProps.id }, () => {
        this.getData()
      })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });

    if (values.id) {

      console.log(JSON.stringify(values));
      customersService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          console.log(res.data);
          toastr.success('ویرایش مشتری', 'مشتری "' + values.title + '" با موفقیت ویرایش شد');
          history.push("/admin/customers")
          setSubmitting(false);

        })
        .catch((error) => {
          console.log(error);
          setSubmitting(false);
        });

    } else {

      console.log(JSON.stringify(values));
      customersService.add(JSON.stringify(values))
        .then((res) => {
          console.log(res);

          this.setState({ loading: false, data: res.data });
          toastr.success('ثبت مشتری جدید', 'مشتری جدید  "' + values.title + '" با موفقیت ثبت شد');
          history.push("/admin/customers")
          setSubmitting(false);


        })
        .catch((error) => {
          setSubmitting(false);

          toastr.error('ثبت مشتری جدید', 'ایمیل یا موبایل وارد شده تکراری است');
        });

    }
  }

  handleError(error) {
    this.setState({ loading: false });
    // toastr.warning('مشکلی پیش آمد', error);
  }

  // validateForm = (errors) => {
  //   if (Object.keys(errors).length > 0) {
  //     // // console.log(errors)
  //     let obj = errors
  //     let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
  //       driverDocuments,
  //       user
  //     } = obj;
  //     if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
  //       this.setState({ key: "info" })
  //     } else if (driverDocuments) {
  //       this.setState({ key: "images" })
  //     }
  //   }
  // }

  render() {
    const { data } = this.state;
    const ValidationSchema = Yup.object().shape({
      title: Yup.string().trim().nullable().required('عنوان تفصیلی'),
      gender: Yup.string().trim().nullable().required('جنسیت'),
      firstName: Yup.string().trim().nullable().required('نام'),
      lastName: Yup.string().trim().nullable().required('نام خانوادگی'),
      // mobile: Yup.string().nullable().matches(/^[0-9]\d{10}$/, { message: "تلفن همراه باید شامل 11 رقم باشد", excludeEmptyString: false })
      //   .trim().required('وارد کردن [تلفن همراه] الزامی است'),
      customerType: Yup.string().trim().nullable().required('نوع مشتری'),
      customerSubType: Yup
        .string().nullable()
        .when("customerTypeIsLegal", {
          is: true,
          then: Yup.string().trim().nullable().required('نوع فرعی'),
        }),
      brands: Yup.array().min(1, 'حداقل 1 برند').required('حداقل 1 برند'),
    });
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          this.handleSubmit(values, setSubmitting);
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm,
          } = props;
          return (
            <div>
              <div className="row" style={{ position: "relative" }}>
                <form onSubmit={handleSubmit}>
                  <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}
                    onClick={() =>
                      validateForm().then(errors => {
                        console.log(errors)
                      })
                    } >
                    {isSubmitting ?
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                      :
                      <AiOutlineSave size="22px" />

                    }
                    ذخیره
                  </button>
                  <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات مشتری">

                      <Step1 {...props} />

                    </Tab>

                    <Tab eventKey="addresses" title="آدرس ها">

                      {this.state.key === "addresses" && values && values.id && (
                        <Step2 {...props} customerId={values && values.id} />
                      )}

                    </Tab>

                    <Tab eventKey="tels" title="تلفن ها">

                      {this.state.key === "tels" && values && values.id && (
                        <Step3 {...props} customerId={values && values.id} />
                      )}

                    </Tab>

                    {/* {values && values.id && [3, 4].includes(values.userType) &&
                      <Tab eventKey="userMessages" title="پیام های مشتری">
                        <UserMessages userId={values.id} />
                      </Tab>
                    } */}

                  </Tabs>
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          );
        }}
      </Formik>
    );
  }
}

export default Form;
